import React, { useEffect, useState } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import jwt_decode from 'jwt-decode';

import './NavMenu.css';

import { logout } from '../redux/authSlice';

export const NavMenu = () => {
    const { pathname } = useLocation();
    const [collapsed, setCollapsed] = useState(true);
    const [selectedSection, setSelectedSection] = useState(pathname);
    const { isAuth, user } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const [isAdmin, setIsAdmin] = useState(null);//user && jwt_decode(user.accessToken).role;

    //console.log(isAdmin, user ? jwt_decode(user.accessToken).role : null, user);

    useEffect(() => {
        if (user) {
            const { accessToken } = user;
            //console.log('TT', accessToken)

            const decoded = jwt_decode(accessToken);
            const role = decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] === 'Администратор' ? 0 : 1;
            setIsAdmin(parseInt(role));
        }
    }, [user]);

    useEffect(() => {
        //console.log(pathname);

        setSelectedSection(pathname);
    }, [pathname]);

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    };

    const logoutHandler = () => {
        dispatch(logout(user));
    };

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
                <NavbarBrand tag={Link} to="/">Фиды</NavbarBrand>
                {isAuth &&
                    <>
                        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                <NavItem className={(selectedSection === "/" || selectedSection === "/projects-page") ? "selectedNavItem" : ""}>
                                    <NavLink tag={Link} className="text-dark" to={!isAuth ? "/login" : "/"}>Проекты</NavLink>
                                </NavItem>
                                <NavItem className={selectedSection.includes("/banners-page") ? "selectedNavItem" : ""}>
                                    <NavLink tag={Link} className="text-dark" to="/banners-page">Запросы</NavLink>
                                </NavItem>
                                {isAdmin === 0 &&
                                    <NavItem className={selectedSection.includes("/users-page") ? "selectedNavItem" : ""}>
                                        <NavLink tag={Link} className="text-dark" to="/users-page">Пользователи</NavLink>
                                    </NavItem>
                                }
                                <NavItem>
                                    <NavLink className='exit-button' onClick={logoutHandler}>Выйти</NavLink>
                                </NavItem>
                            </ul>
                        </Collapse>
                    </>
                }
            </Navbar>
        </header>
    );
}
